import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@/components/ThemeProvider";
import Select from "antd/lib/select";

import "./IndexerInsertStrategy.less";

const INSERT_STRATEGIES = [
  { value: "append", label: "Append (add new rows)" },
  { value: "overwrite", label: "Overwrite (clear existing data)" },
  { value: "upsert", label: "Upsert (update existing, insert new)" }
];

function IndexerInsertStrategy({ insertStrategy, onChange, viewMode, disabled }) {
  const { isDarkMode } = useTheme();
  
  const handleChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  // For display in view mode
  const getStrategyDisplayName = (strategy) => {
    const found = INSERT_STRATEGIES.find(s => s.value === strategy);
    if (found) {
      return found.label;
    }
    return strategy ? strategy.charAt(0).toUpperCase() + strategy.slice(1) : "Append";
  };

  return (
    <div className={`indexer-insert-strategy ${isDarkMode ? 'dark-mode' : ''}`}>
      {viewMode ? (
        <div className="strategy-display">
          {getStrategyDisplayName(insertStrategy)}
        </div>
      ) : (
        <Select
          className="strategy-selector"
          value={insertStrategy || "append"}
          onChange={handleChange}
          disabled={disabled}
        >
          {INSERT_STRATEGIES.map(strategy => (
            <Select.Option key={strategy.value} value={strategy.value}>
              {strategy.label}
            </Select.Option>
          ))}
        </Select>
      )}
    </div>
  );
}

IndexerInsertStrategy.propTypes = {
  insertStrategy: PropTypes.string,
  onChange: PropTypes.func,
  viewMode: PropTypes.bool,
  disabled: PropTypes.bool
};

IndexerInsertStrategy.defaultProps = {
  insertStrategy: "append",
  onChange: null,
  viewMode: false,
  disabled: false
};

export default IndexerInsertStrategy; 